import _ from 'lodash';
import createLocationModel, { prop } from './lib/create_location_model';

export default createLocationModel({
  modelName: 'CustomerView',
  properties: {
    anchor: prop(String),
    isCompositionMinimized: prop(Boolean),
    customerId: prop(String).isRequired,
    currentCompositionId: prop(String),
    currentConversationId: prop(String),
    currentConversationItemId: prop(String),
    isCustomerExtensionPending: prop(Boolean),
    lastRoutedAt: prop(String),
  },

  changeCurrentComposition(compositionId) {
    this.currentCompositionId = compositionId;
  },

  changeCurrentConversation(conversationId) {
    this.currentConversationId = conversationId;
    this.updateRoutedAt();
  },

  changeCurrentConversationItem(conversationItemId) {
    this.currentConversationItemId = conversationItemId;
    this.updateRoutedAt();
  },

  clearCurrentComposition() {
    this.currentCompositionId = null;
  },

  clearCurrentConversation() {
    this.currentConversationId = null;
    this.currentConversationItemId = null;
  },

  clearCurrentConversationItem() {
    this.currentConversationItemId = null;
  },

  setCustomerExtensionPending() {
    this.isCustomerExtensionPending = true;
  },

  clearCustomerExtensionPending() {
    this.isCustomerExtensionPending = false;
  },

  toggleCompositionMinimized() {
    this.isCompositionMinimized = !this.isCompositionMinimized;
  },

  isInComposition(customerId, compositionId) {
    return this.customerId === customerId && this.currentCompositionId === compositionId;
  },

  setAnchor(anchor) {
    this.anchor = anchor;
  },

  updateRoutedAt() {
    this.lastRoutedAt = new Date().toISOString();
  },

  statics: {
    breadcrumb: 'Conversation',
    create(attrs) {
      return new this(_.assign({ lastRoutedAt: new Date().toISOString() }, attrs));
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/customer_view.js